import { cn } from "@utils/tw"
import { ContentBlocks } from "eddev/blocks"
import { motion } from "motion/react"
import { ComponentProps } from "react"

type Props = Omit<ComponentProps<typeof ContentBlocks>, "wrapBlock">

/**
 * Wrapper around ContentBlocks which adds classes based on block type/flags.
 *
 * Any block that doesn't have `selfAnimates: true` will get a blur wrapper around it
 */
export function CenteredBlocks(props: Props) {
  return (
    <ContentBlocks
      blocks={props.blocks}
      wrapBlock={(children, ctx) => {
        // const marginClass = ctx.current.flags?.marginRule && "block-margins-" + ctx.current.flags.marginRule
        const marginClass = ""
        const classes = [marginClass]
        if (ctx.current.blockName.startsWith("core/") || ctx.current.flags?.centered) {
          classes.push("centered-block")
        }
        if (ctx.current.flags?.selfAnimates) {
          return <div className={cn(...classes)}>{children}</div>
        } else {
          return (
            <motion.div
              initial={{
                opacity: 0,
                filter: "blur(20px)",
              }}
              whileInView={{
                opacity: 1,
                filter: "none",
              }}
              exit={{
                opacity: 0,
                filter: "blur(20px)",
              }}
              className={cn(...classes)}
            >
              {children}
            </motion.div>
          )
        }
      }}
      {...props}
    />
  )
}
